<script>
let elslutbleck = {
  title: "Elslutbleck ES19 12/24V Rättvänd",
  info: {
    article: "152090",
    brand: "Safetron",
    brandid: "73289122",
    surface: "Rostfri",
    myarticle: "52612",
    productwidth: "26mm",
    productheight: "90mm",
    doordirection: "Höger, Vänster",
    profilesystem: "Schüco ADS70HD, Stålprofil SP79000, Stålprofil SP979000",
    montagedoorcloser: "Dörr/Karm Gångjärnssida/Karm Anslagssida",
    adjustable: "Nej",
    cableincluded: "Nej",
    contact: "Nej",
  },
};
</script>

<div class="row item-product-spec">
  <div
    class="col-xs-12 col-sm-7 col-md-12 pt-sm pb-sm item-left-spec item-border-top"
  >
    <div class="col-xs-12">
      <div>
        <h4>Specifikation</h4>
      </div>
    </div>

    <div class="product-description mt-xs">
      <div class="product-details-spec col-xs-12 col-sm-10 col-lg-5">
        <div class="fcond fdark">
          <p class="col-xs-12 pl-none pr-none text-uppercase">Artikel:</p>
          <h4 class="col-xs-12">{elslutbleck.info.article}</h4>
        </div>
        <div class="fcond fdark">
          <p class="col-xs-12 pl-none pr-none text-uppercase">Min artikel:</p>
          <h4 class="col-xs-12">{elslutbleck.info.myarticle}</h4>
        </div>
      </div>

      <div class="product-description mt-xs">
        <div class="product-details col-xs-12 col-sm-10 col-lg-5">
          <div class="fcond fdark">
            <p class="col-xs-12  pl-none pr-none text-uppercase">Varumärke:</p>
            <h4 class="col-xs-12">{elslutbleck.info.brand}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12 pl-none pr-none text-uppercase">
              Varumärkes id:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.brandid}</h4>
          </div>
        </div>
      </div>

      <div class="product-description mt-xs">
        <div class="border-line-break col-xs-12"></div>
        <div class="product-details col-xs-12 col-sm-10 col-lg-5">
          <div class="fcond fdark">
            <p class="col-xs-12  pl-none pr-none text-uppercase">
              Ytbehandling:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.surface}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12 pl-none pr-none text-uppercase">Brandtestad:</p>
            <h4 class="col-xs-12">{elslutbleck.info.brandid}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12 pl-none pr-none text-uppercase">
              Bredd produkt:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.productwidth}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12 pl-none pr-none text-uppercase">Profilsystem</p>
            <h4 class="col-xs-12">{elslutbleck.info.profilesystem}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12 pl-none pr-none text-uppercase">
              Dörrhängning:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.doordirection}</h4>
          </div>
        </div>
      </div>

      <div class="product-description mt-xs">
        <div class="product-details col-xs-12 col-sm-10 col-lg-5">
          <div class="fcond fdark">
            <p class="col-xs-12  pl-none pr-none text-uppercase">
              Höjd produkt:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.productheight}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12 pl-none pr-none text-uppercase">
              Montagesätt/dörrstängare:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.montagedoorcloser}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12  pl-none pr-none text-uppercase">
              Justerbar plös:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.adjustable}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12  pl-none pr-none text-uppercase">
              Kabel ingår:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.cableincluded}</h4>
          </div>
          <div class="fcond fdark">
            <p class="col-xs-12  pl-none pr-none text-uppercase">
              Kolvkontakt:
            </p>
            <h4 class="col-xs-12">{elslutbleck.info.contact}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!---- Content show/hide ---->
<div class="collapse item-product-spec" id="collapseExample">
  <div class="well">
    <div class="row item-product-spec">
      <div class="col-xs-12 col-sm-7 col-md-12 item-left-spec">
        <div class="product-description">
          <div class="product-details-spec col-xs-12 col-sm-10 col-lg-5">
            <div class="fcond fdark">
              <p class="col-xs-12 pl-none pr-none text-uppercase">Artikel:</p>
              <h4 class="col-xs-12">{elslutbleck.info.article}</h4>
            </div>
            <div class="fcond fdark">
              <p class="col-xs-12 pl-none pr-none text-uppercase">
                Min artikel:
              </p>
              <h4 class="col-xs-12">{elslutbleck.info.myarticle}</h4>
            </div>
          </div>

          <div class="product-description mt-xs">
            <div class="product-details col-xs-12 col-sm-10 col-lg-5">
              <div class="fcond fdark">
                <p class="col-xs-12  pl-none pr-none text-uppercase">
                  Varumärke:
                </p>
                <h4 class="col-xs-12">{elslutbleck.info.brand}</h4>
              </div>
              <div class="fcond fdark">
                <p class="col-xs-12 pl-none pr-none text-uppercase">
                  Varumärkes id:
                </p>
                <h4 class="col-xs-12">{elslutbleck.info.brandid}</h4>
              </div>
            </div>
          </div>
          <div class="product-description mt-xs">
            <div class="product-details-spec col-xs-12 col-sm-10 col-lg-5">
              <div class="fcond fdark">
                <p class="col-xs-12 pl-none pr-none text-uppercase">Artikel:</p>
                <h4 class="col-xs-12">{elslutbleck.info.article}</h4>
              </div>
              <div class="fcond fdark">
                <p class="col-xs-12 pl-none pr-none text-uppercase">
                  Min artikel:
                </p>
                <h4 class="col-xs-12">{elslutbleck.info.myarticle}</h4>
              </div>
            </div>

            <div class="product-description mt-xs">
              <div class="product-details col-xs-12 col-sm-10 col-lg-5">
                <div class="fcond fdark">
                  <p class="col-xs-12  pl-none pr-none text-uppercase">
                    Varumärke:
                  </p>
                  <h4 class="col-xs-12">{elslutbleck.info.brand}</h4>
                </div>
                <div class="fcond fdark">
                  <p class="col-xs-12 pl-none pr-none text-uppercase">
                    Varumärkes id:
                  </p>
                  <h4 class="col-xs-12">{elslutbleck.info.brandid}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="toggle-item btn btn-light specification-toggle">
  <a
    data-toggle="collapse"
    href="#collapseExample"
    aria-expanded="false"
    aria-controls="collapseExample"
  >
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2L8 8L2 2"
        stroke="#2751BC"
        stroke-width="3"
        stroke-linecap="round"
      ></path>
    </svg>
    Hela specifikationen
  </a>

  <div class="collapse"></div>
</div>
<!---- Button for show/hide ends here ---->
